import { useEffect } from 'react'

import { getAuthPortalUrl } from '@procom-labs/common'

export const PrivacyPolicy = () => {
  useEffect(() => {
    window.location.href = `${getAuthPortalUrl(
      window.location.hostname
    )}/privacy-policy`
  }, [])

  return <div />
}
